/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Statistics_Day_Short_5Inputs */

const he_statistics_day_short_5 = /** @type {(inputs: Statistics_Day_Short_5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ו`)
};

const en_statistics_day_short_5 = /** @type {(inputs: Statistics_Day_Short_5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`F`)
};

/**
* | output |
* | --- |
* | "F" |
*
* @param {Statistics_Day_Short_5Inputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
export const statistics_day_short_5 = /** @type {((inputs?: Statistics_Day_Short_5Inputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Statistics_Day_Short_5Inputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_statistics_day_short_5(inputs)
	return en_statistics_day_short_5(inputs)
});